import SupabaseApi from "../../../api/SupabaseApi";

const FIXED_EXP_VALUE = 100;
const RATIOS = [];
// 100 * 10까지 레벨 가능 지금은 10000임
for (let i = 0; i < 1000; i++) {
  RATIOS.push(i + 1);
}

// 이전 경험치를 다 더하는 적분은 너무 가혹하고
// RATIO(기울기)를 조금씩 올리자

// 200
// 200 + 400
// 200 + 400 + 600

// 10
// 10 + 10

// 한번에 차게 하는 것도 설계해야되네...
// 예를들어 1000이 한번에 뛰면, 레벨이 순식간에 점프 해야됨...

// 후원한 사람 이름 기록...
// 1-10 구간은 두배씩
// 11-20 구간은 세배씩
// 21-30 구간은 네배씩
// 31-40 구간은 다섯배씩

// LEVEL은 99가 맥스

// level 1: 100
// level 2: 200
// level 3: 300

const debugRange = () => {
  const a = [];
  let sum = 0;
  for (let i = 1; i <= 5; i++) {
    sum += calculateCurrentLevelMaxExp(i);
    const s = `[LEVEL] ${i}, [current max] ${calculateCurrentLevelMaxExp(i)}, [sum] ${sum}`;
    a.push(s);
    console.log(s);
  }
  // console.clear();
  // console.log(JSON.stringify(a));
};

const calculateCurrentLevelMaxExp = (level) => {
  let totalExp = 0;
  for (let i = 0; i < level; i++) {
    const index = Math.floor(i / 10);
    totalExp += FIXED_EXP_VALUE * RATIOS[index];
  }
  return totalExp;
};

function calculateCurrentExp(level, totalExp) {
  if (level === 1) return totalExp;

  let calcExp = totalExp;
  // 0 1 2 3 4
  for (let l = 1; l < level; l++) {
    const exp = calculateCurrentLevelMaxExp(l);
    calcExp -= exp;
  }
  return calcExp;
}

export default {
  // 주의: OBS는 토큰 검증(_onAuthed) 이후에야 pet_id가 잡힌다 → created()가 아니라
  // _onAuthed에서 startLevelExp()를 호출해 레벨/경험치를 로드한다.
  data() {
    return {
      level: 1,
      totalExp: 0,
      currentExp: 0,
      nextExp: 0,

      _isEventFired: false,
    };
  },
  methods: {
    // 토큰 검증 후(_onAuthed) 호출. pet_id가 잡힌 뒤 레벨/경험치 로드 + 영속 인터벌 시작.
    async startLevelExp() {
      const { level = 1, totalExp = 0 } = (await SupabaseApi.fetchMyVirtupetLevelMeta()) || {};
      this.level = level;
      this.totalExp = totalExp;
      this.currentExp = calculateCurrentExp(level, totalExp);
      this.nextExp = calculateCurrentLevelMaxExp(level);

      this.updateDisplay();
      this.startPersistInterval();
    },
    startPersistInterval() {
      if (this._interval) return;
      this._interval = setInterval(async () => {
        if (this._isEventFired) {
          this._isEventFired = false;
          await this.persist();
        }
      }, 1000);
    },
    clearPersistInterval() {
      clearInterval(this._interval);
    },
    async increaseExp(exp) {
      try {
        this.totalExp += exp;

        let isLevelUp = false;

        const isLevelUpNeed = this.nextExp <= this.currentExp + exp;
        if (isLevelUpNeed) {
          let expectTotalExp = this.currentExp + exp;
          while (this.nextExp <= expectTotalExp) {
            // level up
            expectTotalExp -= this.nextExp;
            this.level++;
            this.currentExp = 0;
            this.nextExp = calculateCurrentLevelMaxExp(this.level);
          }
          const remainExp = expectTotalExp;
          this.currentExp += remainExp;

          isLevelUp = true;

          this._isEventFired = false;
          await this.persist();
        } else {
          this.currentExp += exp; //calculateCurrentExp(level, totalExp) // 자주 발생하는 이벤트라..
        }

        this._isEventFired = true;
        this.updateDisplay();
      } catch (error) {
        console.error("E_NOT_INCREASE_EXP");
        console.error(error);
      }
    },
    // persist가 너무 자주 일어나면 애니메이션 딜레이로 이어질것 같다...
    async persist() {
      await SupabaseApi.upsertVirtupetLevel(this.level, this.totalExp);
    },
    updateDisplay() {
      // 호스트(BroadcastBox)의 displayExp로 전달
      if (typeof this.displayExp === "function") {
        this.displayExp(this.level, this.currentExp, this.nextExp);
      }
    },
  },
};
